<template>
    <div class="mt10 mb10">
        <el-dropdown placement="bottom-start" :disabled="isView" @command="handleCommand">
            <el-button type="primary" :disabled="isView" plain size="mini">
                <i class="el-icon-plus"></i> 添加条件
            </el-button>

            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="current">添加同级条件</el-dropdown-item>
                <el-dropdown-item command="child" :disabled="disabledChild||data.depth==3">添加下级条件</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    export default {
        name: "AddConditionBtn",
        props:{
            data:{
                type:Object,
                default(){
                    return {
                        condition:[],
                    }
                }
            },
        },
        inject:['isView'],
        data(){
            return {

            }
        },
        computed:{
            disabledChild(){
                let condition = this.data.condition;
                if(Array.isArray(condition)){
                    return condition.some(item=>item.logic);
                }
                return false;
            },
        },
        methods:{
            handleCommand(val){
                this.$emit('add',val);
            }
        }
    }
</script>

<style scoped>

</style>
